import { Box, Flex } from '@televet/kibble-ui/build/chakra';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import format from 'date-fns/format';
import React from 'react';
import { ReadableRenewalRejectionReason } from './records/activityLogCard.records';
import { EnrollmentEventData } from './types';

interface EnrollmentEventCardBodyProps {
  data: EnrollmentEventData;
}

export const EnrollmentEventCardBody = ({ data }: EnrollmentEventCardBodyProps): JSX.Element => {
  const { currentPlanTitle, previousPlanTitle, renewalDate, renewalRejectionReason } = data;

  return (
    <Box>
      {currentPlanTitle && (
        <Flex alignItems="center" mb={1}>
          <Icon name="starSolid" size="sm" variant="subtle" />
          <Text as="p" size="sm" ml={1} variant="subtle">
            Current Plan: {currentPlanTitle}
          </Text>
        </Flex>
      )}
      {previousPlanTitle && (
        <Flex alignItems="center" mb={1}>
          <Icon name="star" size="sm" variant="subtle" />
          <Text as="p" size="sm" ml={1} variant="subtle">
            Previous Plan: {previousPlanTitle}
          </Text>
        </Flex>
      )}
      {renewalRejectionReason && (
        <Flex alignItems="center" mb={1}>
          <Icon name="questionMarkCircle" size="sm" variant="subtle" />
          <Text as="p" size="sm" ml={1} variant="subtle">
            Rejection Reason: {ReadableRenewalRejectionReason[renewalRejectionReason]}
          </Text>
        </Flex>
      )}
      {renewalDate && (
        <Flex alignItems="center" mb={1}>
          <Icon name="arrowCircle" size="sm" variant="subtle" />
          <Text as="p" size="sm" ml={1} variant="subtle">
            Renewal Date: {format(new Date(renewalDate), 'MM/dd/yyyy')}
          </Text>
        </Flex>
      )}
    </Box>
  );
};
